export const IMG = {
  hero: "https://images.unsplash.com/photo-1584432810601-6c7f27d2362b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  elderly: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  scrubs: "https://images.unsplash.com/photo-1765896387398-1e1ae8d2eb85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  bp: "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  walker: "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  activity: "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  archive: "https://images.unsplash.com/photo-1676281050264-178eff38874a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const PHONE = "[0115 000 0000]";
export const EMAIL = "[hello@trentvale-nursing.co.uk]";

export const COUNTIES = ["Nottinghamshire", "Derbyshire", "Leicestershire", "Lincolnshire", "Northamptonshire", "Rutland"];

export const SERVICES = [
  {
    slug: "agency-nursing",
    no: "01",
    title: "Agency nursing staff",
    short: "RGNs, RMNs, RNLDs and senior carers for hospitals, care homes and clinics.",
    long: "Short-notice and block-booked cover for NHS wards, private hospitals, nursing homes and specialist units. Every nurse is NMC-checked, DBS-cleared and clinically briefed before they arrive.",
    points: ["Same-day shift cover", "Block bookings", "Night & weekend rotas"],
    img: "bp",
  },
  {
    slug: "complex-care",
    no: "02",
    title: "Complex care",
    short: "Nurse-led packages for tracheostomy, PEG, ventilation and acquired brain injury.",
    long: "Clinically led care at home for adults and children with complex needs. Packages are designed with your CHC team, overseen by a named clinical lead and reviewed continuously.",
    points: ["Clinical lead oversight", "CHC-funded packages", "Competency-trained teams"],
    img: "scrubs",
  },
];

export const TESTIMONIALS = [
  { quote: "They covered three night shifts on our surgical ward with four hours' notice. Every nurse arrived briefed and ready.", name: "[Ward Manager]", org: "[NHS Trust, Nottingham]" },
  { quote: "Mum has the same two carers every week. She knows their names, they know her stories. That's everything.", name: "[Family member]", org: "[Client family, Derby]" },
  { quote: "The complex care team understood my son's trach care better than anyone we'd worked with before.", name: "[Parent]", org: "[Complex care client, Leicester]" },
];
